// * MUI Components
import { Box, Container, Typography, styled } from "@mui/material";
import { TrendingUp, Psychology, Speed } from "@mui/icons-material";

// * Styled Components
const CustomTextBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(7),
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 5, 0, 5),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: theme.spacing(5),
  },
}));

const Divider = styled("div")(({ theme }) => ({
  width: "13%",
  height: "5px",
  backgroundColor: "#3370FF",
  [theme.breakpoints.down("md")]: {
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

const SmallText = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  color: "#7B8087",
  fontWeight: "500",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
}));

export default function MoreDetail() {
  return (
    <Container sx={{ marginTop: 6, marginBottom: 8 }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Divider sx={{ margin: "0 auto", mb: 3 }} />
        <Typography
          sx={{
            fontSize: "35px",
            color: "#2B3674",
            fontWeight: "700",
            mb: 3,
          }}
        >
          Why Dizpurse Exists
        </Typography>

        <Typography
          sx={{
            fontSize: "18px",
            color: "#2B3674",
            lineHeight: "32px",
            maxWidth: "800px",
            margin: "0 auto",
            mb: 2,
          }}
        >
          Money management tools show you what you spent.
        </Typography>
        <Typography
          sx={{
            fontSize: "20px",
            color: "#3370FF",
            lineHeight: "32px",
            maxWidth: "800px",
            margin: "0 auto",
            fontWeight: "600",
            mb: 3,
          }}
        >
          Dizpurse takes action automatically so you don't have to.
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            color: "#4A5568",
            lineHeight: "28px",
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          We're building the first automation engine for personal finance—rules, transfers, alerts, and money flows all programmable. No more manual transfers. No more forgetting to save. No more spreadsheets. Just smart automation that keeps your money working for you.
        </Typography>
      </Box>

      <CustomTextBox>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              backgroundColor: "#E6F0FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TrendingUp sx={{ fontSize: 35, color: "#3370FF" }} />
          </Box>
          <SmallText sx={{ color: "#2B3674", fontWeight: "600" }}>
            Not just tracking
          </SmallText>
          <SmallText sx={{ textAlign: "center", px: 2 }}>
            We move your money, not just show it
          </SmallText>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              backgroundColor: "#FFE9E3",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Psychology sx={{ fontSize: 35, color: "#FF6B3D" }} />
          </Box>
          <SmallText sx={{ color: "#2B3674", fontWeight: "600" }}>
            Built for discipline
          </SmallText>
          <SmallText sx={{ textAlign: "center", px: 2 }}>
            Automation you can trust to stay consistent
          </SmallText>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              backgroundColor: "#F0E9FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Speed sx={{ fontSize: 35, color: "#4318FF" }} />
          </Box>
          <SmallText sx={{ color: "#2B3674", fontWeight: "600" }}>
            Real-time action
          </SmallText>
          <SmallText sx={{ textAlign: "center", px: 2 }}>
            Respond instantly to your spending patterns
          </SmallText>
        </Box>
      </CustomTextBox>
    </Container>
  );
}
